// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import './util/rem.js'

Vue.config.productionTip = false
// import vueXlsxTable from 'vue-xlsx-table'
// Vue.use(vueXlsxTable, {rABS: true})

import htmlToPdf from '@/util/html2pdf'
Vue.use(htmlToPdf)
//判断是否是移动设备
let isMobile = window.outerWidth>760 ? false : true
Vue.prototype.$isMobile = isMobile

import {Divider,Cascader,Progress,Upload,Dialog,Form,FormItem,Loading,Link,PageHeader,submenu,MenuItemGroup,Menu,MenuItem,Card,Tabs,TabPane,Pagination,RadioGroup,RadioButton,Dropdown,DropdownItem,DropdownMenu,Radio,Input,Row,Col,Checkbox,CheckboxGroup,Tag,Button,Table,TableColumn,Select,Option, Message,Backtop,Icon} from 'element-ui'
Vue.use(Divider).use(Cascader).use(Progress).use(Upload).use(Dialog).use(FormItem).use(Form).use(Link).use(PageHeader).use(MenuItemGroup).use(submenu).use(MenuItem).use(Menu).use(Card).use(TabPane).use(Tabs).use(Pagination).use(RadioGroup).use(RadioButton).use(DropdownMenu).use(DropdownItem).use(Dropdown).use(Radio).use(Input).use(Row).use(Col).use(Checkbox).use(CheckboxGroup).use(Tag).use(Button).use(Option).use(Select ).use(Table).use(TableColumn).use(Backtop).use(Icon)

import axios from './util/axios.js'
Vue.prototype.$axios = axios
Vue.prototype.$loading  =Loading

Vue.prototype.message = Message

import serviceAPI from './serviceAPI.js'
Vue.prototype.$serviceAPI = serviceAPI
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js